import React from "react";
import PropTypes from "prop-types";

const Row = (props) => {
	return (<div className="u-clear" style={props.style}>
		{props.children}
	</div>);
};

Row.propTypes = {
	children: PropTypes.node,
	style:PropTypes.object
};

export default Row;
